import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Dashboard from "./Components/Dashboard/Dashboard";
import AllUsers from "./Pages/AllUsers/AllUsers";
import AllBlogs from "./Pages/Blogs/AllBlogs";
import AddBlog from "./Pages/Blogs/AddBlog";
import UpdateBlog from "./Pages/Blogs/UpdateBlog";
import SingleBlog from "./Pages/Blogs/SingleBlog";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import AddProducts from "./Pages/Products/AddProducts";
import AllProducts from "./Pages/Products/AllProducts";
import SingleProduct from "./Pages/Products/SingleProduct";
import UpdateProduct from "./Pages/Products/UpdateProduct";
import Profile from "./Pages/Profile/Profile";
import AllLabtest from "./Pages/AllLabtest/AllLabtest";

const App = () => {
  return (
    <>
      <Router>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Dashboard AnotherComponent={<Home />} />} />
          <Route
            path="/admin/all-users"
            element={<Dashboard AnotherComponent={<AllUsers />} />}
          />
          <Route
            path="/admin/all-products"
            element={<Dashboard AnotherComponent={<AllProducts />} />}
          />
          <Route
            path="/admin/add-product"
            element={<Dashboard AnotherComponent={<AddProducts />} />}
          />{" "}
          <Route
            path="/admin/add-blog"
            element={<Dashboard AnotherComponent={<AddBlog />} />}
          />
          <Route
            path="/admin/update-product/:id"
            element={<Dashboard AnotherComponent={<UpdateProduct />} />}
          />
          <Route
            path="/admin/single-product/:id"
            element={<Dashboard AnotherComponent={<SingleProduct />} />}
          />
          <Route
            path="/admin/profile"
            element={<Dashboard AnotherComponent={<Profile />} />}
          />
          <Route
            path="/admin/all-blogs"
            element={<Dashboard AnotherComponent={<AllBlogs />} />}
          /> 
          <Route
            path="/admin/all-labtests"
            element={<Dashboard AnotherComponent={<AllLabtest />} />}
          />
          <Route
            path="/admin/update-blog/:id"
            element={<Dashboard AnotherComponent={<UpdateBlog />} />}
          />
          <Route
            path="/admin/single-blog/:id"
            element={<Dashboard AnotherComponent={<SingleBlog />} />}
          />
          <Route path="/admin/login" element={<Login />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
